import {
  Clock, Target, TrendingUp, MapPin,
  Building2, Hammer, Palette, Grid3X3, Waves, Shield,
} from "lucide-react";

// Services for Bento Grid on landing (links to /sluzby/:slug)
export const services = [
  {
    id: 1,
    slug: "stavby-na-kluc",
    title: "Stavby na kľúč",
    description: "Kompletná výstavba rodinného domu od projektu až po odovzdanie.",
    icon: Building2,
    price: "Individuálne",
    span: "col-span-12 md:col-span-8",
    image: "https://images.pexels.com/photos/934029/pexels-photo-934029.jpeg?auto=compress&w=800",
    featured: true,
  },
  {
    id: 2,
    slug: "holodomy",
    title: "Holodomy",
    description: "Hrubá stavba pripravená na dokončenie.",
    icon: Hammer,
    price: "od 960€/m²",
    span: "col-span-12 md:col-span-4",
    image:
      "https://static.prod-images.emergentagent.com/jobs/e3dd95cb-332c-4595-a6d9-da61903a36a5/images/57370a23a54f952d1dbd9341bea48216366f4b523f41c506368ed745223585d0.png",
  },
  {
    id: 3,
    slug: "rekonstrukcie",
    title: "Rekonštrukcie",
    description: "Kompletné prestavby domov a bytov.",
    icon: Palette,
    price: "Individuálne",
    span: "col-span-12 md:col-span-4",
    image:
      "https://static.prod-images.emergentagent.com/jobs/e3dd95cb-332c-4595-a6d9-da61903a36a5/images/db4a49c5e78bf72b9585560a2eaaf176fec98d0f1b17bcbcc4b05f6bc735e73b.png",
  },
  {
    id: 4,
    slug: "zateplenie",
    title: "Zateplenia",
    description: "Profesionálne zateplenie fasád s úsporou 40%.",
    icon: Shield,
    price: "od 48€/m²",
    span: "col-span-12 md:col-span-4",
    highlight: true,
  },
  {
    id: 5,
    slug: "zamkova-dlazba",
    title: "Zámková dlažba",
    description: "Príjazdové cesty, chodníky, terasy.",
    icon: Grid3X3,
    price: "od 70€/m²",
    span: "col-span-12 md:col-span-4",
  },
  {
    id: 6,
    slug: "bazeny",
    title: "Bazény",
    description: "Výstavba bazénov na kľúč.",
    icon: Waves,
    price: "Individuálne",
    span: "col-span-12 md:col-span-4 lg:col-span-6",
  },
];

export const stats = [
  { value: "15+", label: "Rokov skúseností", icon: Clock },
  { value: "500+", label: "Dokončených projektov", icon: Target },
  { value: "98%", label: "Spokojných klientov", icon: TrendingUp },
  { value: "7", label: "Okresov pokrytia", icon: MapPin },
];

export const pricing = [
  { title: "Holodomy", price: "960", unit: "€/m²", features: ["Zemné práce", "Základy", "Murivo", "Strecha", "Okná"] },
  { title: "Zateplenie", price: "48", unit: "€/m²", features: ["Polystyrén", "Lepidlá", "Omietka", "Lešenie", "Doprava"], featured: true },
  { title: "Betónové ploty", price: "56", unit: "€/bm", features: ["Stĺpiky", "Panely", "Cement", "Montáž", "Záruka"] },
  { title: "Základy RD", price: "90", unit: "€/m²", features: ["Výkopy", "Debnenie", "Armatúra", "Betón", "Izolácia"] },
  { title: "Zámková dlažba", price: "70", unit: "€/m²", features: ["Podklad", "Štrk", "Dlažba", "Obrubníky", "Škárovanie"] },
  { title: "Sadrokartón", price: "32", unit: "€/m²", features: ["SDK dosky", "Konštrukcia", "Tmelenie", "Brúsenie", "S materiálom"] },
];

export const testimonials = [
  {
    text: "Konečne firma, ktorá dodržala termín aj rozpočet. Dom hotový za 8 mesiacov presne ako v zmluve.",
    author: "Martin K.",
    role: "Majiteľ RD, Senec",
    avatar: "MK",
  },
  {
    text: "Zateplenie domu prebehlo bez problémov. Profesionálny prístup a ušetrili sme 40% na energiách.",
    author: "Jana S.",
    role: "Bratislava",
    avatar: "JS",
  },
  {
    text: "Rekonštrukcia kúpeľne a kuchyne za 3 týždne. Komunikácia cez WhatsApp bola perfektná.",
    author: "Peter H.",
    role: "Trnava",
    avatar: "PH",
  },
];

export const portfolio = [
  { id: 1, title: "Vila Pezinok", category: "Novostavba", image: "https://images.pexels.com/photos/934029/pexels-photo-934029.jpeg?w=600" },
  { id: 2, title: "Rekonštrukcia BA", category: "Interiér", image: "https://images.unsplash.com/photo-1769736436759-1c43688ef899?w=600" },
  { id: 3, title: "Rodinný dom Senec", category: "Holodom", image: "https://images.pexels.com/photos/30580640/pexels-photo-30580640.jpeg?w=600" },
  { id: 4, title: "Bazén Trnava", category: "Exteriér", image: "https://images.pexels.com/photos/8134750/pexels-photo-8134750.jpeg?w=600" },
];

export const locations = [
  // Bratislava kraj
  "Bratislava", "Petržalka", "Ružinov", "Nové Mesto", "Karlova Ves", "Dúbravka", "Rača",
  "Senec", "Ivanka pri Dunaji", "Bernolákovo", "Dunajská Lužná", "Rovinka", "Miloslavov",
  "Hviezdoslavov", "Kvetoslavov", "Hrubá Borša",
  "Pezinok", "Modra", "Svätý Jur", "Slovenský Grob", "Šenkvice",
  "Malacky", "Stupava", "Lozorno", "Zohor",
  // Trnavský kraj
  "Trnava", "Piešťany",
  "Dunajská Streda", "Šamorín", "Veľký Meder", "Gabčíkovo", "Lehnice",
  "Galanta", "Sereď", "Sládkovičovo",
  // Nitriansky kraj
  "Šaľa",
];

// Shared animation variants
export const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
  },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.6 } },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
  },
};

export const stagger = {
  visible: { transition: { staggerChildren: 0.15 } },
};
